// Plain-Russian names for the raw audit-event `type` codes so the reports
// timeline (and anywhere else) never shows bare snake_case.

export const AUDIT_LABEL = {
  // shift lifecycle
  shift_materialized: 'Смена создана по графику',
  schedule_materialization: 'Смена собрана из графика',
  scheduled_assignment: 'Назначен сотрудник по графику',
  employee_confirmed: 'Сотрудник подтвердил подъём',
  wake_up_confirmed: 'Подъём подтверждён',
  shift_opened: 'Смена открыта',
  task_completed: 'Задача выполнена',
  task_cancelled_for_handover: 'Задача снята при передаче смены',
  shift_closed: 'Смена закрыта штатно',
  shift_force_closed: 'Смену закрыл администратор',

  // handover
  handover_requested: 'Запрошена передача смены',
  handover: 'Передача смены',
  handover_completed: 'Передача смены завершена',

  // wake-up incidents
  wake_up_request: 'Напоминание проснуться перед сменой',
  wake_up_missing: 'Сотрудник не подтвердил подъём',
  wake_up_incident_acknowledged: 'Администратор принял инцидент',
  wake_up_incident_resolved: 'Инцидент по выходу закрыт',
  wake_up_replacement: 'Назначена замена сотрудника',
  alert_redelivery: 'Повторная отправка уведомления',

  // admin overrides
  admin_reassignment: 'Администратор сменил сотрудника',
  admin_override: 'Ручное вмешательство администратора',

  // configuration
  location_created: 'Создана точка',
  location_updated: 'Изменена точка',
  shiftType_created: 'Создан тип смены',
  shiftType_updated: 'Изменён тип смены',
  user_created: 'Добавлен сотрудник',
  user_updated: 'Изменён сотрудник',
  checklist_template_created: 'Создан чек-лист',
  checklist_template_updated: 'Изменён чек-лист',
  task_template_added: 'Добавлена задача в чек-лист',
  task_template_updated: 'Изменена задача',
  task_template_removed: 'Задача убрана из чек-листа',
  schedule_entry_created: 'Смена добавлена в график',
  schedule_entry_updated: 'Смена в графике изменена',
  schedule_entry_cancelled: 'Смена убрана из графика',
  shift_cancelled_with_schedule: 'Смена отменена вместе с записью графика',
  schedule_self_signup: 'Сотрудник записался на смену',
  schedule_self_withdraw: 'Сотрудник снял свою смену',
};

const humanize = (code) =>
  String(code || 'событие')
    .replace(/[_:]+/g, ' ')
    .replace(/^\s+|\s+$/g, '')
    .replace(/^./, (c) => c.toUpperCase());

export const describeAudit = (type) => AUDIT_LABEL[type] || humanize(type);
